/*eslint-disable */
import React from "react";

declare const window: any;

interface CategoriasComponentProps {
  maintanance: any;
}

const CategoriasComponent: React.FC<CategoriasComponentProps> = ({
  maintanance,
}) => {
  return (
    <div className="categorias-posventa-mantenimiento-container">
      <div className="cars-categorias-posventa-mantenimiento-container">
        {maintanance?.map((item: any) => (
          <div className="car" key={item?.id}>
            <img 
              className="vehicle" 
              src={`https://manager.hyundaicolombia.co/${item?.media?.url}`} 
              alt={item?.title || "Imagen del vehículo Hyundai"} 
            />
            <div className="title">{item?.title}</div>
            <div className="subtitle">{item?.text1}</div>
            <div className="description">{item?.text2}</div>
            <a target="blank" href={item?.url_button} className="btnn">
              {item?.button_text}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoriasComponent;
